/**
 * Data e aktivizimit — pasqyrimi i `backend/services/activation.js`.
 *
 * Verdikti i vërtetë merret nga serveri (hyrja, `requireAuth`, `activation_status`
 * te /api/users): ai e di zonën e kompanisë dhe «sot» të saj. Këto ndihmëse
 * shërbejnë vetëm për EKRANIN — një etiketë pranë datës ndërsa HR-ja e shkruan,
 * një çip te profili — dhe nuk vendosin asgjë për qasjen.
 *
 *   ActivationDate bosh        → aktiv (sjellja e mëparshme)
 *   ActivationDate <= sot      → aktiv
 *   ActivationDate >  sot      → `pending_activation`
 */

export const PENDING_ACTIVATION = 'pending_activation';

/** `YYYY-MM-DD` ose `''`. Pranon ISO, `dd.mm.yyyy`, `Date`. */
export function toYMD(v) {
  if (v === null || v === undefined || v === '') return '';
  if (v instanceof Date) {
    if (Number.isNaN(v.getTime())) return '';
    const p = (n) => String(n).padStart(2, '0');
    return `${v.getFullYear()}-${p(v.getMonth() + 1)}-${p(v.getDate())}`;
  }
  const s = String(v).trim();
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (m) return `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
  return '';
}

/** Dita e sotme e browser-it, `YYYY-MM-DD` (ora lokale, jo UTC). */
export function todayYMD(now = new Date()) {
  return toYMD(now);
}

export function formatDMY(v) {
  const d = toYMD(v);
  if (!d) return '';
  const [y, m, dd] = d.split('-');
  return `${dd}.${m}.${y}`;
}

/** `true` kur data e aktivizimit është PAS `today`. Bosh = jo në pritje. */
export function isPendingActivation(activationDate, today = todayYMD()) {
  const d = toYMD(activationDate);
  return Boolean(d) && d > String(today);
}

/** `'pending_activation'` ose `'active'` për një datë. */
export function activationStatus(activationDate, today = todayYMD()) {
  return isPendingActivation(activationDate, today) ? PENDING_ACTIVATION : 'active';
}

/**
 * Statusi i një LLOGARIE: `inactive` | `pending_activation` | `active`.
 * Preferon verdiktin e serverit (`activationStatus`) kur ka; ndryshe llogarit
 * nga data — p.sh. për rreshtat e vjetër që s'e sollën fushën.
 */
export function accountStatus(u, today = todayYMD()) {
  if (!u) return 'active';
  if (u.active === false) return 'inactive';
  const server = u.activationStatus ?? u.activation_status;
  if (server) return server === PENDING_ACTIVATION ? PENDING_ACTIVATION : 'active';
  return activationStatus(u.activationDate ?? u.activation_date, today);
}

/** Fjalori i çipit të llogarisë — një vend, që listat të mos ndahen. */
export const ACCOUNT_STATUS_CHIP = {
  inactive:           { label: 'Joaktiv',                  color: 'default', variant: 'outlined' },
  pending_activation: { label: 'Në pritje të aktivizimit', color: 'warning', variant: 'filled' },
  active:             { label: 'Aktiv',                    color: 'success', variant: 'filled' },
};

export function accountStatusChip(u, today = todayYMD()) {
  return ACCOUNT_STATUS_CHIP[accountStatus(u, today)] || ACCOUNT_STATUS_CHIP.active;
}
